<template>
  <div>
    <PolkaBtnIcon
      shape="round"
      class="mb-2"
      :active="isFavoriteLot"
      :aria-label="isFavoriteLot ? 'Удалить из избранного' : 'Добавить в избранное'"
      @click="handleClickSaveButton"
    >
      <template #off>
        <HeartIcon />
      </template>
      <template #on>
        <HeartFillIcon />
      </template>
    </PolkaBtnIcon>

    <div
      v-click-outside="hideProvidersMenu"
      class="relative"
    >
      <PolkaBtnIcon
        shape="round"
        class="mb-2"
        aria-label="Поделиться"
        @click="handleClickShared"
      >
        <ShareIcon />
      </PolkaBtnIcon>
      <div
        v-if="isShowProvidersMenu"
        class="top-10 absolute right-0 mx-1 overflow-hidden rounded-[12px]"
      >
        <RmBtn
          color="super-light"
          class="w-48 py-2"
          @click="handleClickVk"
        >
          <VkIcon class="absolute left-0 w-6 h-6 ml-4" />

          <div class="ml-4 text-gray-900">Vk</div>
        </RmBtn>
        <RmBtn
          color="super-light"
          class="w-48 py-2"
          @click="handleClickFb"
        >
          <FacebookIcon class="absolute left-0 w-6 h-6 ml-4" />
          <div class="ml-4 text-gray-900">Facebook</div>
        </RmBtn>
        <RmBtn
          color="super-light"
          class="w-48 py-2"
          @click="handleClickSaveUrl"
        >
          <LinkIcon class="absolute left-0 w-6 h-6 ml-4" />
          <div class="ml-4 text-gray-900">
            {{ $t('lots.id.copyLink') }}
          </div>
        </RmBtn>
      </div>
    </div>
  </div>
</template>

<script setup>
import FacebookIcon from '~/assets/svg/lot-page/facebook.svg?component'
import HeartFillIcon from '~/assets/svg/lot-page/heart-fill.svg?component'
import HeartIcon from '~/assets/svg/lot-page/heart.svg?component'
import LinkIcon from '~/assets/svg/lot-page/link.svg?component'
import ShareIcon from '~/assets/svg/lot-page/share.svg?component'
import VkIcon from '~/assets/svg/lot-page/vk.svg?component'
import PolkaBtnIcon from '~/components/shared/polka_btn_icon.vue'
import RmBtn from '~/components/shared/rm_btn.vue'
import { useLot } from '~/composables/useLot'
import copyToClipboard from '~/utils/copyToClipboard'

const props = defineProps({
  lotId: {
    type: [String, Number],
    default: 0,
  },
  pageUrl: {
    type: String,
    default: '',
  },
  pageTitle: {
    type: String,
    default: '',
  },
  pageDescription: {
    type: String,
    default: '',
  },
  pageImages: {
    type: Array,
    default: () => [],
  },
  quote: {
    type: String,
    default: '',
  },
  hashtag: {
    type: String,
    default: '',
  },
  minRentDays: {
    type: Number,
    default: 1,
  },
})

const { $modal, $t } = useNuxtApp()
const { lot, setFavorite } = useLot(props.lotId)
const { isSignedIn } = useAuth()
const { favoritLotAdd, favoritLotRemove } = useFavorites()

const isFavoriteLot = computed(() => lot.value?.isFavorite)
const isShowProvidersMenu = ref(false)

function handleClickSaveButton () {
  if (isFavoriteLot.value) {
    handleClickRemoveLotFromFavorites()
  } else {
    handleClickSaveLotInFavorites()
  }
}

async function handleClickSaveLotInFavorites () {
  if (!isSignedIn.value) {
    $modal.show('flow/auth')
  } else {
    const result = await favoritLotAdd({ lotId: props.lotId, source: 'LOT' })
    if (result) {
      setFavorite(true)
    }
  }
}

async function handleClickRemoveLotFromFavorites () {
  const result = await favoritLotRemove(props.lotId)
  if (result) {
    setFavorite(false)
  }
}

function handleClickShared () {
  isShowProvidersMenu.value = !isShowProvidersMenu.value
}

function hideProvidersMenu () {
  isShowProvidersMenu.value = false
}

function handleClickVk () {
  hideProvidersMenu()
  const width = 640
  const height = 480
  const url = `https://vk.com/share.php?
      url=${encodeURIComponent(props.pageUrl)}
      &title=${encodeURIComponent(props.pageTitle)}
      &image=${encodeURIComponent(props.pageImages[0]?.medium)}
      &noparse=true`
  openPopUpWindow(url, width, height)
}

function handleClickFb () {
  hideProvidersMenu()
  const width = 640
  const height = 480
  const url = `https://www.facebook.com/sharer.php
      ?u=${encodeURIComponent(props.pageUrl)}
      &description=${encodeURIComponent(props.pageDescription)}
      &title=${encodeURIComponent(props.pageTitle)}
      &quote=${encodeURIComponent(props.quote)}
      &hashtag=${encodeURIComponent(props.hashtag)}`
  openPopUpWindow(url, width, height)
}

async function handleClickSaveUrl () {
  hideProvidersMenu()
  if (await copyToClipboard(props.pageUrl)) {
    const { notify } = useNotification()
    notify({
      type: 'success',
      text: $t('lots.id.copiedLink'),
      duration: 1500,
    })
  }
}

function openPopUpWindow (url, width, height) {
  const cleanUrl = url.replace(/\s/g, '')
  const left = Math.round(document.documentElement.clientWidth / 2 - width / 2)
  const top = Math.round(document.documentElement.clientHeight / 2 - height / 2)
  const config = `width=${width},height=${height},left=${left},top=${top}`

  return window.open(cleanUrl, null, `${config},toolbar=no,menubar=no,scrollbars=no`)
}
</script>
